// File: src/app/layout.tsx
import { Outlet } from "react-router-dom";
import { Container } from "react-bootstrap";
import { Topbar } from "@/components/topbar";
import { Footer } from "@/components/footer";
import { useEffect, useState } from "react";
import { UserContext, User } from "./usercontext";
import { authFetch } from "@/lib/auth-fetch";

export default function AppLayout() {
    const [user, setUser] = useState<User | null>(null);

    useEffect(() => {
        let mounted = true;
        authFetch("/auth/me")
            .then(res => res.ok ? res.json() : null)
            .then((data) => {
                if (!mounted) return;
                if (data) {
                    setUser({ name: data.name, username: data.username, role: data.role });
                } else {
                    setUser(null);
                }
            })
            .catch(() => setUser(null));
        return () => { mounted = false; };
    }, []);

    return (
        <UserContext.Provider value={user}>
            <div className="app-layout">
                <Topbar />
                <main className="app-content">
                    <Container>
                        <Outlet />
                    </Container>
                </main>
                <Footer />
            </div>
        </UserContext.Provider>
    );
}